@if (inboxState) {
  <div class="h-100 w-100 mizen-inbox" ngbDropdown display="dynamic">
    <button class="btn btn-dark btn-sm" id="open-inbox" ngbDropdownToggle type="button">
      <span aria-hidden="true" class="fas fa-inbox fa-2x fa-fw"></span>
      @if (inboxState.total > 0) {
        <span
          class="badge badge-pill badge-primary mizen-inbox__pill">{{ inboxState.total }}</span>
      }
      <span hidden>{{ 'inbox.title' | translate }}</span>
    </button>
    <div aria-labelledby="open-inbox" ngbDropdownMenu>
      @if (inboxState.unreadNotifications.length > 0) {
        @for (notification of inboxState.unreadNotifications; track notification) {
          <a [href]="getNotificationURL(notification)"
             class="mizen-inbox__notification" target="_blank" [title]="'inbox.notification.title' | translate"
             ngbDropdownItem>
            <span [hidden]="noAttachments" class="mizen-inbox__notification-paperclip">
              <i [hidden]="notification.attachmentList.length <= 0"
                 class="fas fa-paperclip "></i>
            </span>
            {{ notification.createDateTime | datumZeit }}
            :&nbsp;<strong>{{ notification.title }}</strong> - {{ notification.message }}
          </a>
        }
      }
      @if (inboxState.unreadNotifications.length <= 0) {
        <a [href]="inboxPath" target="_blank" [title]="'inbox.open.title' | translate"
           ngbDropdownItem>{{ 'inbox.open' | translate }}</a>
      }
    </div>
  </div>
}
